import React from 'react';
import { Badge } from 'antd';

const statusFormat = {
  1: {
    status: 'warning',
    text: 'Brouillon'
  },
  2: {
    status: 'success',
    text: 'Actif'
  },
  3: {
    status: 'processing',
    text: 'Inactif'
  },
  4: {
    status: 'default',
    text: 'Archivé'
  }
}

const Status = ({ statusId }) =>
  <div className="p-wrap">
    <Badge status={statusFormat[statusId].status} />
    {statusFormat[statusId].text}
  </div>

Status.defaultProps = {
  statusId: 4
}

export default Status;


// WEBPACK FOOTER //
// src/components/status/Status.js